import React from 'react';
import InputMask from 'react-input-mask';

interface CustomerBasicFieldsProps {
  // Form values
  name: string;
  setName: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  birthdate: string;
  setBirthdate: (value: string) => void;
  gender: string;
  setGender: (value: string) => void;
  telephone: string;
  setTelephone: (value: string) => void;

  // Validation states
  alarmName: boolean;
  setAlarmName: (value: boolean) => void;
  alarmEmail: boolean;
  setAlarmEmail: (value: boolean) => void;
  alarmBirthdate: boolean;
  setAlarmBirthdate: (value: boolean) => void;
  alarmTelephone: boolean;
  setAlarmTelephone: (value: boolean) => void;

  // Masks and handlers
  maskTelephone: string;
  changeTelephone: (phone: string) => void;
  setHideMenu: (value: boolean) => void;

  // Config
  haveFieldConfig: boolean;
  fieldsConfig: any[];
  createFieldDinamycally: (field: any) => JSX.Element | undefined;

  //validador
  isCNPJ: boolean;
}

export function CustomerBasicFields({
  name, setName, email, setEmail, birthdate, setBirthdate,
  gender, setGender, telephone, setTelephone,
  alarmName, setAlarmName, alarmEmail, setAlarmEmail,
  alarmBirthdate, setAlarmBirthdate, alarmTelephone, setAlarmTelephone,
  maskTelephone, changeTelephone, setHideMenu,
  haveFieldConfig, fieldsConfig, createFieldDinamycally,isCNPJ
}: CustomerBasicFieldsProps) {

  if (haveFieldConfig) {
    return (
      <>
        <div className="input">
          <label>Nome do Comprador</label>
          <input
            className={`${alarmName && "alarm-input"}`}
            type="text"
            value={name}
            onChange={(event) => setName(event.target.value)}
            onFocus={() => setHideMenu(true)}
            onBlur={() => {
              setName(name.replaceAll("  ", " "));
              setHideMenu(false);
              name === undefined || name === ""
                ? setAlarmName(true)
                : setAlarmName(false);
            }}
          />
          {alarmName && (
            <p className="alarm-text">Informe um nome</p>
          )}
        </div>
        {fieldsConfig.map((fieldConfig: any) =>
          createFieldDinamycally(fieldConfig)
        )}
      </>
    );
  }

  return (
    <>
      <div className="input">
        <label>Nome do Comprador</label>
        <input
          className={`${alarmName && "alarm-input"}`}
          type="text"
          value={name}
          onChange={(event) => setName(event.target.value)}
          onFocus={() => setHideMenu(true)}
          onBlur={() => {
            setName(name.replaceAll("  ", " "));
            setHideMenu(false);
            name === undefined || name === ""
              ? setAlarmName(true)
              : setAlarmName(false);
          }}
        />
        {alarmName && (
          <p className="alarm-text">Informe um nome</p>
        )}
      </div>

      <div className="input">
        <label>E-mail</label>
        <input
          className={`${alarmEmail && "alarm-input"}`}
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          onFocus={() => setHideMenu(true)}
          onBlur={() => {
            setHideMenu(false);
            email === undefined ||
              email === "" ||
              !email.includes("@")
              ? setAlarmEmail(true)
              : setAlarmEmail(false);
          }}
        />
        {alarmEmail && (
          <p className="alarm-text">Informe um e-mail válido</p>
        )}
      </div>
      {!isCNPJ && (
        <div className="input">
          <label>Data de Nascimento</label>
          <InputMask
            className={`${alarmBirthdate && "alarm-input"}`}
            mask={"99/99/9999"}
            placeholder="XX/XX/XXXX"
            type="text"
            value={birthdate}
            onChange={(event) => setBirthdate(event.target.value)}
            onFocus={() => setHideMenu(true)}
            onBlur={() => {
              setHideMenu(false);
              birthdate === undefined ||
                birthdate === "" ||
                birthdate[1] === "_"
                ? setAlarmBirthdate(true)
                : setAlarmBirthdate(false);
            }}
          />
          {alarmBirthdate && (
            <p className="alarm-text">
              Informe uma data de nascimento
            </p>
          )}
        </div>
      )}
      <div className="input">
        <label>Gênero</label>
        <select
          onChange={(e) => setGender(e.target.value)}
          value={gender}
        >
          <option value="masculino">Masculino</option>
          <option value="feminino">Feminino</option>
          <option value="none">Não Informar</option>
        </select>
      </div>

      <div className="input">
        <label>Telefone do cadastro</label>
        <InputMask
          className={`${alarmTelephone && "alarm-input"}`}
          mask={maskTelephone}
          placeholder="DDD + Telefone"
          type="text"
          value={telephone}
          onBeforeInputCapture={(event) =>
            changeTelephone(event.currentTarget.value)
          }
          onChange={(event) => setTelephone(event.target.value)}
          onFocus={() => setHideMenu(true)}
          onBlur={() => {
            setHideMenu(false);
            telephone[1] === "_"
              ? setAlarmTelephone(true)
              : setAlarmTelephone(false);
          }}
        />
        {alarmTelephone && (
          <p className="alarm-text">Informe o telefone</p>
        )}
      </div>
    </>
  );
}
